// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"maincontent_mainContent__1yZQD","rotated":"maincontent_rotated__2z1nc","page":"maincontent_page__3_Wcb"};